(function (angular) {
    'use strict';

    angular.module('Common')

        .factory('apiSpacePicker',
            ['$q', '$rootScope', '$state', '$stateParams', 'apiSpacesService', 'localStorageService', 'jwtService',
                function ($q, $rootScope, $state, $stateParams, apiSpacesService, localStorageService, jwtService) {

                    var deferred;

                    var apiSpaces;
                    var picked = 0;

                    $rootScope.$on('jwtService.clear', function (event) {
                        deferred = undefined;
                    });

                    var fac = {
                        getApiSpaces: getApiSpaces,
                        getPicked: getPicked,
                        getPickedApiSpace: getPickedApiSpace,
                        setPicked: setPicked,
                        updateApiSpaces: updateApiSpaces,
                        updateApiSpace: updateApiSpace,
                        addApiSpace: addApiSpace,
                        deleteApiSpace: deleteApiSpace,
                        initialise: initialise
                    };
                    return fac;

                    /**
                     * 
                     */
                    function getApiSpaces() {
                        return apiSpaces;
                    }

                    /**
                     * 
                     */
                    function addApiSpace(apiSpace) {
                        if (!apiSpaces) {
                            apiSpaces = [];
                        }
                        apiSpaces.push(apiSpace);
                        if (!picked) {
                            setPicked(0);
                        }
                        var currPicked = getPickedApiSpace();
                        apiSpaces.sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                        });
                        var newPicked = apiSpaces.map(function (apiSpace) { return apiSpace.id; }).indexOf(currPicked.id);
                        if (newPicked != picked) {
                            picked = newPicked;
                            $rootScope.$broadcast('apiSpacesUpdate:picked', newPicked);
                        }
                        $rootScope.$broadcast('apiSpacesUpdate:content');
                    }

                    /**
                     * 
                     */
                    function updateApiSpaces(newApiSpaces) {
                        apiSpaces = newApiSpaces;
                        $rootScope.$broadcast('apiSpacesUpdate:content');
                    }

                    /**
                     * 
                     */
                    function deleteApiSpace(apiSpace) {
                        var index = 0;
                        for (; index < apiSpaces.length; index++) {
                            if (apiSpace.id == apiSpaces[index].id) {
                                break;
                            }
                        }
                        apiSpaces.splice(index, 1);
                        if (index === picked && apiSpaces.length) {
                            picked = 0;
                            $rootScope.$broadcast('apiSpacesUpdate:picked');
                        }
                        $rootScope.$broadcast('apiSpacesUpdate:deleted');
                        return picked;
                    }

                    /**
                     * 
                     */
                    function getPicked() {
                        return picked;
                    }

                    /**
                     * 
                     */
                    function getPickedApiSpace() {
                        return apiSpaces[picked];
                    }

                    /**
                     * 
                     */
                    function updateApiSpace(apiSpace) {
                        for (var index in apiSpaces) {
                            if (apiSpace.id == apiSpaces[index].id) {
                                apiSpaces[index] = apiSpace;
                            }
                        }
                        $rootScope.$broadcast('apiSpacesUpdate:content');
                    }
                    /**
                     * 
                     */
                    function setPicked(newPicked) {
                        picked = newPicked;
                        var params = $stateParams;
                        if (params.hasOwnProperty('pickedApiSpaceId')) {
                            params.pickedApiSpaceId = apiSpaces[picked].id;
                            $state.go('.', params);
                        }
                        $rootScope.$broadcast('apiSpacesUpdate:picked', apiSpaces[picked].id);
                    }
                    /**
                     * 
                     */
                    function initialise() {

                        if (deferred) {
                            return deferred.promise;
                        } else {

                            deferred = $q.defer();

                            if(!jwtService.payload){
                                return $q.reject();
                            }
                            var cookieName = 'apiSpaces_' + jwtService.payload.userId;

                            apiSpacesService.getApiSpaces()
                                .then(function (response) {
                                    apiSpaces = response;

                                    if (apiSpaces.length) {

                                        apiSpaces.sort(function (a, b) {
                                            return a.name.localeCompare(b.name);
                                        });

                                        var cookie = localStorageService.getItem(cookieName);

                                        // update
                                        if ($state.params.pickedApiSpaceId && cookie != $state.params.pickedApiSpaceId) {
                                            localStorageService.setItem(cookieName, $state.params.pickedApiSpaceId);
                                            cookie = localStorageService.getItem(cookieName);
                                        }

                                        if (cookie) {

                                            angular.forEach(apiSpaces, function (apiSpace, index) {
                                                if (apiSpace.id == cookie) {
                                                    picked = index;
                                                    fac.setPicked(picked);
                                                }
                                            })

                                        }
                                        else {
                                            fac.setPicked(picked);
                                            localStorageService.setItem(cookieName, fac.getPickedApiSpace().id);
                                        }
                                    }

                                    deferred.resolve(true);
                                })
                                .catch(function (error) {
                                    deferred.reject(error);
                                });

                            return deferred.promise;
                        }

                    }
                }]);

})(window.angular);
